<template>
  <section class="section">
    <div class="glass-container animate__animated animate__fadeIn">
      <div class="level mb-6">
        <div class="level-left">
          <div>
            <h1 class="title is-2 has-text-white mb-2">Restaurantes</h1>
            <p class="subtitle is-6 has-text-grey-lighter">Gestiona los restaurantes vinculados a tus eventos</p>
          </div>
        </div>
        <div class="level-right">
          <b-button 
            type="is-primary" 
            icon-left="plus" 
            class="is-rounded glass-btn"
            @click="abrirModal(null)"
          >
            Nuevo Restaurante
          </b-button>
        </div>
      </div>

      <!-- Filtros -->
      <div class="columns mb-4">
        <div class="column is-4">
          <b-field label="Filtrar por Evento" label-position="on-border" class="glass-field">
            <b-select v-model="idEvento" @input="obtenerRestaurantes" expanded class="is-rounded">
              <option :value="null">Todos los eventos</option>
              <option v-for="e in eventos" :key="e.id" :value="e.id">
                {{ e.nombre }} {{ e.activo == 1 ? '(Activo)' : '' }}
              </option>
            </b-select>
          </b-field>
        </div>
      </div>

      <div class="table-container glass-table">
        <b-table 
          :data="restaurantes" 
          :hoverable="true" 
          :loading="cargando"
          mobile-cards
        >
          <b-table-column field="nombre" label="Restaurante" v-slot="props">
            <div class="is-flex is-align-items-center">
              <figure class="image is-32x32 mr-3">
                <img :src="urlLogo(props.row.logo)" class="is-rounded" style="object-fit: cover; height: 32px;">
              </figure>
              <span class="has-text-weight-bold">{{ props.row.nombre }}</span>
            </div>
          </b-table-column>

          <b-table-column field="ciudad" label="Ubicación" v-slot="props">
            {{ props.row.ciudad }}
          </b-table-column>

          <b-table-column field="activo" label="Estado" v-slot="props" centered>
            <span
              class="tag is-rounded"
              :class="props.row.activo == 1 ? 'is-success' : 'is-danger'"
            >
              {{ props.row.activo == 1 ? 'Activo' : 'Inactivo' }}
            </span>
          </b-table-column>

          <b-table-column field="acciones" label="Acciones" v-slot="props" centered>
            <div class="buttons is-centered">
              <b-button
                type="is-info"
                size="is-small"
                icon-left="pencil"
                class="is-rounded glass-action"
                @click="abrirModal(props.row)"
              >
                Editar
              </b-button>
              <b-button
                type="is-danger"
                size="is-small"
                icon-left="trash"
                class="is-rounded glass-action"
                @click="confirmarEliminacion(props.row.id)"
              >
                Eliminar
              </b-button>
            </div>
          </b-table-column>

          <template #empty>
            <div class="has-text-centered py-6">
              <b-icon icon="emoticon-sad" size="is-large" class="has-text-grey-light"></b-icon>
              <p class="has-text-grey mt-2">No se encontraron restaurantes para este evento.</p>
            </div>
          </template>
        </b-table>
      </div>
    </div>

    <b-modal :active.sync="modalActivo" has-modal-card :can-cancel="['escape', 'x', 'outside']">
      <form-restaurante @registrar="registrarRestaurante" :restauranteProp="restauranteActual" :idEventoProp="idEvento" />
    </b-modal>
  </section>
</template>

<script>
import FormRestaurante from './FormRestaurante.vue';
import HttpService from '../../Servicios/HttpService';
import Utiles from '../../Servicios/Utiles';
import Swal from 'sweetalert2';

export default {
  name: 'RestaurantesComponent',
  components: { FormRestaurante },
  data() {
    return {
      restaurantes: [],
      eventos: [],
      idEvento: null,
      cargando: false,
      restauranteActual: null,
      modalActivo: false
    };
  },
  mounted() {
    this.cargarDatosIniciales();
  },
  methods: {
    cargarDatosIniciales() {
      this.cargando = true;
      HttpService.registrar('eventos.php', { accion: 'actual' })
        .then(eventoActual => {
          if (eventoActual) this.idEvento = eventoActual.id;
          
          return Promise.all([
            HttpService.registrar('eventos.php', { accion: 'obtener' }),
            this.obtenerRestaurantes()
          ]);
        })
        .then(([eventos]) => {
          this.eventos = eventos || [];
          this.cargando = false;
        });
    },
    obtenerRestaurantes() {
      this.cargando = true;
      return HttpService.registrar('restaurantes.php', { accion: 'obtener', id_evento: this.idEvento })
        .then(res => {
          this.restaurantes = (res || []);
          this.cargando = false;
        });
    },
    urlLogo(logo) {
      if (!logo) return 'api/imgproductos/sinimagen.webp';
      if (logo.includes('http')) return logo;
      const apiBase = Utiles.regresarRuta().split('api')[0];
      return apiBase + logo;
    },
    registrarRestaurante(restaurante) {
      this.cargando = true;
      const accion = restaurante.id ? 'editar' : 'registrar';
      HttpService.registrar('restaurantes.php', { accion, restaurante })
        .then(res => {
          if (res) {
            Swal.fire({
              icon: 'success',
              title: restaurante.id ? 'Actualizado' : 'Registrado',
              timer: 2000,
              showConfirmButton: false
            });
            this.restauranteActual = null;
            this.modalActivo = false;
            this.obtenerRestaurantes();
          }
        });
    },
    abrirModal(r) {
      if (r) {
        this.cargando = true;
        HttpService.registrar('productos.php', { accion: 'obtener_por_restaurante', restaurante_id: r.id, evento_id: this.idEvento })
          .then(prod => {
            this.restauranteActual = { ...r, activo: !!Number(r.activo) };
            if (prod) {
              this.restauranteActual.producto_vinculado = prod;
            }
            this.modalActivo = true;
            this.cargando = false;
          });
      } else {
        this.restauranteActual = null;
        this.modalActivo = true;
      }
    },
    confirmarEliminacion(id) {
      Swal.fire({
        title: '¿Eliminar restaurante?',
        text: 'Esta acción no se puede deshacer',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#ff3860',
        confirmButtonText: 'Sí, eliminar',
        cancelButtonText: 'Cancelar'
      }).then((result) => {
        if (result.isConfirmed) {
          this.eliminar(id);
        }
      });
    },
    eliminar(id) {
      this.cargando = true;
      HttpService.registrar('restaurantes.php', { accion: 'eliminar', id })
        .then(res => {
          if (res) {
            Swal.fire({
              icon: 'success',
              title: 'Eliminado',
              timer: 1500,
              showConfirmButton: false
            });
            this.obtenerRestaurantes();
          }
        });
    }
  }
};
</script>

<style scoped>
.glass-container {
  background: rgba(15, 23, 42, 0.6);
  backdrop-filter: blur(20px);
  border-radius: 24px;
  padding: 40px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.5);
  min-height: 80vh;
}

.glass-field /deep/ .label {
  color: #94a3b8 !important;
  font-weight: 500;
}

.glass-field /deep/ .select select {
  background: rgba(255, 255, 255, 0.05) !important;
  border: 1px solid rgba(255, 255, 255, 0.1) !important;
  color: white !important;
  border-radius: 12px !important;
}

.glass-field /deep/ .select select option {
  background: #1e293b;
  color: white;
}

.glass-table /deep/ .table {
  background: transparent !important;
  color: white !important;
}

.glass-table /deep/ .table thead th {
  background: rgba(255, 255, 255, 0.03) !important;
  color: #3b82f6 !important;
  border-bottom: 2px solid rgba(255, 255, 255, 0.1);
  padding: 15px;
}

.glass-table /deep/ .table td {
  border-bottom: 1px solid rgba(255, 255, 255, 0.05);
  vertical-align: middle;
  color: rgba(255, 255, 255, 0.9);
  padding: 15px;
}

.glass-btn {
  background: linear-gradient(135deg, #3b82f6 0%, #1e40af 100%) !important;
  border: none !important;
  color: white !important;
  box-shadow: 0 8px 16px rgba(59, 130, 246, 0.2);
}

.glass-action {
  background: rgba(255, 255, 255, 0.05) !important;
  border: 1px solid rgba(255, 255, 255, 0.1) !important;
  color: #94a3b8 !important;
  transition: all 0.3s ease;
}

.glass-action:hover {
  background: rgba(255, 255, 255, 0.1) !important;
  color: white !important;
  border-color: rgba(255, 255, 255, 0.2) !important;
}

.is-success.tag { background-color: #10b981 !important; }
.is-danger.tag { background-color: #ef4444 !important; }

@media screen and (max-width: 768px) {
  .section { padding: 15px 10px; }
  .glass-container { padding: 20px; }
}
</style>
